import { Controller } from "react-hook-form";
import { ImageUploader, ThemedText } from "@/components/ui";

const MediaDocumentStep = ({ control }) => {
    return (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {/* Foto Profil */}
            <Controller
                name="photo_profile"
                control={control}
                render={({ field }) => (
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-col">
                            <ThemedText size="sm" className="font-medium">
                                Foto Profil
                            </ThemedText>
                            <ThemedText size="xs" variant="secondary">
                                Ditampilkan di daftar staff
                            </ThemedText>
                        </div>
                        <ImageUploader
                            images={field.value || []}
                            onChange={field.onChange}
                            maxFiles={1}
                        />
                    </div>
                )}
            />

            {/* Foto Pribadi */}
            <Controller
                name="photo_personal"
                control={control}
                render={({ field }) => (
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-col">
                            <ThemedText size="sm" className="font-medium">
                                Foto Pribadi
                            </ThemedText>
                            <ThemedText size="xs" variant="secondary">
                                Untuk keperluan internal
                            </ThemedText>
                        </div>
                        <ImageUploader
                            images={field.value || []}
                            onChange={field.onChange}
                            maxFiles={1}
                        />
                    </div>
                )}
            />

            {/* Foto KTP */}
            <Controller
                name="identity_card_photo"
                control={control}
                render={({ field }) => (
                    <div className="flex flex-col gap-2">
                        <ThemedText size="sm" className="font-medium">
                            Foto KTP
                        </ThemedText>
                        <ImageUploader
                            images={field.value || []}
                            onChange={field.onChange}
                            maxFiles={1}
                        />
                    </div>
                )}
            />

            {/* Foto NPWP */}
            <Controller
                name="tax_identification_number_photo"
                control={control}
                render={({ field }) => (
                    <div className="flex flex-col gap-2">
                        <ThemedText size="sm" className="font-medium">
                            Foto NPWP
                        </ThemedText>
                        <ImageUploader
                            images={field.value || []}
                            onChange={field.onChange}
                            maxFiles={1}
                        />
                    </div>
                )}
            />
        </div>
    );
};

export default MediaDocumentStep;
